export default __webpack_public_path__ + "static/media/success_circle.6706c4cc.png";